import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PlatformService } from "services/platform.service";

export class Unit {
	index: number;
	by_size_index: number;
	id: number;             // unititemtypeid
	rate: number;           // costeddctotal
	desc: string;           // sunitdesc
	dim: string;            // widxhgt
	area: number;           // area
	truck: boolean;         // bclimate (small) or balarm (big)
	trailer: boolean;       // always true unless parking bay
	sizerank: string;       // sizerank 1/2/3
	few_left: boolean;      // bpower
	one_left: boolean;      // iada
	on_sale: boolean;       // bservicerequired
	free_month: boolean;    // binside
	unlocked: boolean;      // initially false
	parking: boolean;        // if the word "parking" is in the description

	first_month_free: boolean;       // binside
	one_month_half_price: boolean;   // bservicerequired
	three_month_half_price: boolean; // iada
}

export class LocationUnits {
	all: Unit[];
	by_size: { [ size: string]: Unit[] };
}

@Injectable({
	providedIn: 'root'
})
export class UnitService {

	private agent_id = '1'
	private agent_token = '87494AF1-4446-4400-8448-D7F0552155E7'

	private locations: { [location: string]: LocationUnits } = {}

	constructor(private platform: PlatformService, private http: HttpClient) { }

	public get_units(location_id: number): Promise<LocationUnits> {
		const url = 'https://api.rentastore.co.za/Handler.UnitItem.ashx'

		return new Promise<LocationUnits>((resolve, reject) => {
			if (this.platform.isServer) {
				return null
			}
			else if (location_id in this.locations) {
				resolve(this.locations[location_id])
			} else this.http
			.get<any>(url, {
				headers: new HttpHeaders ('Authorization: Basic ' + btoa(this.agent_id + ':' + this.agent_token)),
				params: {
					id: '',
					siteid: location_id.toString(),
					unititemtypeid: '',
					sort: 'area',
					desc: '',
					page: '',
					rows: ''
				}
			})
			.toPromise()
			.then(response => {
				let location_units: LocationUnits = {
					all: [],
					by_size: {
						'any': [],
						'small': [],
						'medium': [],
						'large': [],
						'parking': [],
					}
				}
				if (!Array.isArray(response.items.item)) {
					response.items.item = [response.items.item];
				}
				for (let item of response.items.item) {
					let unit: Unit = {
						index: location_units.all.length,
						by_size_index: 0,
						id: item.unititemtypeid,
						rate: Number.parseFloat(item.rental),
						desc: item.sunitdesc,
						dim: item.widxhgt,
						area: Number.parseFloat(item.area)*0.01,
						truck: item.bclimate == 'True' || item.balarm == 'True',
						trailer: true,
						sizerank: '',
						few_left: item.bpower == 'True',
						one_left: item.iada != '0',
						on_sale: item.bservicerequired == 'True',
						free_month: item.binside == 'True',
						unlocked: false,
						parking: false,
						first_month_free: item.specialid == '3',
						one_month_half_price: item.specialid == '2',
						three_month_half_price: item.specialid == '4',
					}

					// if (unit.on_sale) continue;

					switch (item.ranksml) {
						case '0': unit.sizerank = 'small'; break
						case '1': unit.sizerank = 'medium'; break
						case '2': unit.sizerank = 'large'; break
						default: continue
					}

					if (/parking/.test(item.sunitdesc.toLowerCase())) {
						unit.parking = true
						unit.trailer = false
						unit.sizerank = 'parking'
					} else {
						location_units.by_size['any'].push(unit)
					}

					if (unit.sizerank in location_units.by_size) {
						unit.by_size_index = location_units.by_size[unit.sizerank].length
						location_units.by_size[unit.sizerank].push(unit)
					} else {
						unit.by_size_index = 0
						location_units.by_size[unit.sizerank] = [unit]
					}

					location_units.all.push(unit)
				}
				this.locations[location_id] = location_units
				resolve(location_units)
			})
			.catch(() => reject())
		})
	}
}

export var UnitSpaceEstimate: { [dim: string]: string; } = {
	//Existing sizes with descriptions from 2019 website
	'1,5 x 2': "Can store contents of one small room.",
	'1,5 x 3': "Can store contents of one or two small rooms.",
	'1,8 x 2,7': "Can store contents of one or two small rooms.",
	'1 x 2': "Can store contents of an extra large cupboard or one small room.",
	'2 x 1': "Can store contents of an extra large cupboard or one small room.",
	'2 x 2': "Can store contents of two small rooms.",
	'2 x 3': "Can store contents of two small rooms.",
	'2 x 3,5': "Can store contents of two small rooms.",
	'4 x 2': "Can store contents of two small rooms.", // -indicator that there is a possibily for same unit with numbers swapped around within the sitelink API.
	'4 x 3,5': "Can store contents of four small rooms.",
	'3 x 3': "Can store contents of two or three small rooms.",
	'3 x 4': "Can store contents of three or four small rooms.",
	'3 x 4,5': "Can store contents of four small rooms.",
	'3 x 5': "Can store contents of four or five small rooms.",
	'3 x 6': "Can store contents of five or six small rooms.",
	'3 x 7': "Can store contents of six or seven small rooms.",
	'3 x 9': "Can store contents of eight or nine small rooms.",
	'4,5 x 8': "Can store stock of business inventory and a vehicle or contents of about eleven rooms.",
	'4 x 3': "Can store contents of three or four small rooms.",
	'4 x 10,2': "Can store stock of business inventory, big long items or contents of about thirteen rooms.",
	'4 x 4,5': "Can store contents of five or six small rooms.",
	'4 x 7': "Can store stock of business inventory and a vehicle or contents of about nine rooms.",
	'4 x 7,5': "Can store stock of business inventory and a vehicle or contents of about nine rooms.",
	'5 x 6': "Can store stock of business inventory or contents of about nine rooms.",
	'6 x 6': "Can store stock of business inventory and a vehicle or contents of about eleven rooms.",
	',9 x ,9': "For those extra special small things.",

	// calculated
	'4 x 2,5':	"Can store contents of three small rooms.",//
	'2 x 5,5':	"Can store contents of three small rooms.",
	'2,3 x 6':	"Can store contents of four small rooms.",
	'4 x 4':	"Can store contents of five small rooms.",
	'5,6 x 20':	"Approximately 280 cubic meters of space.",
	'1,3 x 1':	"Can store contents of an extra large cupboard.",

	//new room sizes from space estimator project
	'1 x 1': "For those extra special small things.",
	'1,5 x 1': "Can store contents of an extra large cupboard.",//
	'2 x 5': "Can store contents of three small rooms.",//
	'2,5 x 5': "Can store contents of four small rooms.", //
	'2,8 x 5,5': "Can store contents of five small rooms.",//
	'2,5 x 8': "Can store contents of six small rooms.",//
	'3 x 2': "Can store contents of two small rooms.",
	'1,4 x 1': "For those extra special small things.",
	'6,3 x 20': "Can store stock of large business large inventory or equipment.",
	',9 x 1,3': "For those extra special small things.",
	'4 x 8': "Can store stock of business inventory and a vehicle or contents of about nine rooms.",
	'2 x 4': "Can store contents of two or three small rooms.",
	'4 x 5': "Can store contents of six or seven small rooms.",
	'3 x 5,5': "Can store contents of five small rooms.",//
	'3 x 6,5': "Can store contents of six small rooms.",//
	'3 x 8': "Can store contents of seven or eight small rooms.",//
	'3,4 x 3,8': "Can store contents of four small rooms.",//
	'3,5 x 4': "Can store contents of four small rooms.",//
	'3,5 x 6': "Can store contents of six or seven small rooms.",//
	'4 X 4': "Can store contents of five small rooms.",//
	'4 X 4,5': "Can store contents of five or six small rooms.",
	'5 x 5': "Can store stock of business inventory or contents of about eight rooms.",//
	'4,5 x 6': "Can store stock of business inventory or contents of about eight rooms.",//
	'4,9 x 6,7': "Can store stock of business inventory and a vehicle or contents of about ten rooms.", //
	'6 x 6,5': "Can store stock of business inventory and a vehicle or contents of about twelve rooms.", //
	'5,9 x 7,1': "Can store stock of business inventory and a vehicle or contents of about twelve rooms.",
	'6 x 9': "Massive unit for business inventory and equipments."
}

function dim_area(dim: string): number {
	const [width, length] = dim.split('x').map(part => Number.parseFloat(part.trim().replace(',', '.')))
	return width * length
}

const unit_space_estimate_areas: { dim: string, area: number }[] =
	Object.keys(UnitSpaceEstimate).map(dim => ({ dim, area: dim_area(dim) }))

// Falls back to the description of whichever known size is closest in area, when there's no
// description for this exact size (e.g. a newly added unit size at a new location).
export function get_space_estimate(unit: Unit): string {
	if (UnitSpaceEstimate[unit.dim]) return UnitSpaceEstimate[unit.dim]

	let closest = unit_space_estimate_areas[0]
	for (const candidate of unit_space_estimate_areas) {
		if (Math.abs(candidate.area - unit.area) < Math.abs(closest.area - unit.area)) {
			closest = candidate
		}
	}
	return closest ? UnitSpaceEstimate[closest.dim] : ''
}
